import TagImgAndText from './TagImgAndText'
export default TagImgAndText
